import React from 'react';

interface IProps {
    isLoading: boolean;
    children?: React.ReactNode;
}

const Spinner: React.FC<IProps> = ({ isLoading, children }) => {
    return (
        <div>
            {isLoading && 
                <div className="flex justify-center mt-10">
                    <i className="text-6xl animate-spin-slow fad fa-spinner p-10" />
                </div>
            }

            <div className={isLoading ? "hidden" : ''}>
                {children}
            </div>
        </div>
    )
}

export default Spinner